export default {
	SET_UPLOAD_FILE: 'FORMDATA_SET_UPLOAD_FILE',
	RESET_UPLOAD_FILE: 'FORMDATA_RESET_UPLOAD_FILE',
	SET_HEARTRATE_VALUE: 'FORMDATA_SET_HEARTRATE_VALUE',
	SET_POWER_VALUE: 'FORMDATA_SET_POWER_VALUE',
	SET_SPEED_VALUE: 'FORMDATA_SET_SPEED_VALUE',
};
